import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BLMMapPage from "./components/BLMMapPage";
import { AppProvider, useAppContext } from "./context/AppContext";
import { HeaderProvider, useHeaderContext } from "./context/HeaderContext";
import Navbar from "./components/Navbar";
// import Sidebar from "./components/Sidebar";
import BottomNav from "./components/BottomNav";
import HomePage from "./pages/HomePage";
import HeadlinesPage from "./pages/HeadlinesPage";

import PlanPage from "./pages/PlanPage";
import TripPlannerPage from "./pages/TripPlannerPage";
import GearPage from "./pages/GearPage";
import MapPage from "./pages/MapPage";
// import TestPage from "./pages/TestPage"; // Removed for production
// import DebugPage from "./pages/DebugPage";
import VendorsPage from "./pages/VendorsPage";
import BLMPage from "./pages/BLMPage";
// import BLMCard from "./components/BLMCard"; // Replaced by BLMMapPage
import PersistentHeader from "./components/PersistentHeader";
import OnxPage from "./pages/OnxPage";
import AdminPage from "./pages/AdminPage";
import OSShellDemoPage from "./pages/OSShellDemoPage";
import ProvidersPage from "./pages/ProvidersPage";
import HowToPage from "./pages/HowToPage";
import SafetyWatchPage from "./pages/SafetyWatchPage";


const MainLayout = () => {
  const { darkMode, mode, user: appUser, currentTab, setCurrentTab, setHideBottomNav, hideBottomNav } = useAppContext();
  const { setUser: setHeaderUser } = useHeaderContext();

  // Sync user from AppContext to HeaderContext
  React.useEffect(() => {
    setHeaderUser(appUser);
  }, [appUser, setHeaderUser]);

  // Read tab parameter from URL and set current tab on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tabParam = params.get('tab');
    const isEmbedded = params.get('embedded') === 'true' || params.get('wordpress') === 'true';
    
    if (tabParam) {
      setCurrentTab(decodeURIComponent(tabParam));
    }
    setHideBottomNav(isEmbedded);
  }, [setCurrentTab, setHideBottomNav]);

  let Content;
  switch (currentTab) {
    case "Bureau of Land Management (BLM)":
      Content = <BLMMapPage />;
      break;
    case "BLMCard":
      Content = <BLMMapPage />;
      break;
    case "Home":
      Content = <HomePage />;
      break;
    case "Headlines":
      Content = <HeadlinesPage />;
      break;
    case "Plan":
      Content = <PlanPage />;
      break;
    case "Gear":
      Content = <GearPage />;
      break;
    case "Map":
      Content = <MapPage />;
      break;
    case "Vendors":
      Content = <VendorsPage />;
      break;
    case "BLM":
      Content = <BLMMapPage />;
      break;
    case "BLM Recreation Points":
      Content = <BLMMapPage />;
      break;
    case "OnX":
      Content = <OnxPage />;
      break;
    case "Admin":
      Content = <AdminPage />;
      break;
    case "BLM Map Page":
      Content = <BLMMapPage />;
      break;
    case "Trip Planner":
      Content = <TripPlannerPage />;
      break;
    case "OS Shell":
      Content = <OSShellDemoPage />;
      break;
    case "Providers":
      Content = <ProvidersPage />;
      break;
    case "How To":
      Content = <HowToPage />;
      break;
    case "Safety Watch":
      Content = <SafetyWatchPage />;
      break;
    // case "Test":
    //   Content = <TestPage />;
    //   break;
    // case "Debug":
    //   Content = <DebugPage />;
    //   break;
  }

  return (
    <div className={darkMode ? "dark" : ""}>
      {mode === "beginner" && <PersistentHeader />}
      <div className="flex min-h-screen bg-gray-100 dark:bg-gray-800">
        {/* Sidebar Navigation removed for production */}
        {/* <Sidebar currentTab={currentTab} setCurrentTab={setCurrentTab} /> */}
        {/* Main content */}
        <div className="flex-1 flex flex-col">
          {currentTab !== "OS Shell" && <Navbar />}
          {/* ✅ Add padding-bottom so content clears the bottom nav */}
          <main className={`flex-1 ${currentTab !== "OS Shell" ? "p-4 pt-16 pb-20" : ""}`}>{Content}</main>
        </div>
        {/* Bottom Navigation Bar */}
        {!hideBottomNav && currentTab !== "OS Shell" && (
          <BottomNav currentTab={currentTab} setCurrentTab={setCurrentTab} />
        )}
      </div>
    </div>
  );
};


// AppProvider must wrap HeaderProvider so all hooks are called within their correct provider
const App = () => (
  <AppProvider>
    <HeaderProvider>
      <MainLayout />
    </HeaderProvider>
  </AppProvider>
);

export default App;
